import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=71d5d206&scoped=true&"
import script from "./Study.vue?vue&type=script&lang=js&"
export * from "./Study.vue?vue&type=script&lang=js&"
import style0 from "./Study.vue?vue&type=style&index=0&id=71d5d206&prod&lang=scss&scoped=true&"
import style1 from "./Study.vue?vue&type=style&index=1&id=71d5d206&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5d206",
  null
  
)

export default component.exports